module.exports = __webpack_public_path__ + "static/media/UneteFormacionContinua.673a7923.svg";